import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "user-center-page"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "user-info-item"
};
const _hoisted_4 = {
  class: "avatar-container"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  key: 1,
  class: "ri-user-line default-avatar"
};
const _hoisted_7 = {
  class: "user-info-item-title"
};
const _hoisted_8 = {
  class: "name"
};
const _hoisted_9 = {
  class: "highlight-text"
};
const _hoisted_10 = {
  class: "profession-info"
};
const _hoisted_11 = {
  key: 0,
  class: "profession"
};
const _hoisted_12 = {
  class: "user-info-wrap"
};
const _hoisted_13 = {
  class: "card-title-box"
};
const _hoisted_14 = {
  class: "card-title-btn"
};
const _hoisted_15 = {
  class: "wechat-info"
};
const _hoisted_16 = {
  class: "creator-info"
};
const _hoisted_17 = {
  class: "creator-info"
};
const _hoisted_18 = {
  class: "vip-text"
};
const _hoisted_19 = {
  class: "baseInfo flex-column-box"
};
const _hoisted_20 = {
  key: 0,
  class: "flex-row-box"
};
const _hoisted_21 = {
  class: "flex-row-box avatar",
  style: {
    "flex-grow": "2",
    "justify-content": "flex-start"
  }
};
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  key: 1,
  class: "ri-user-line default-avatar"
};
const _hoisted_24 = {
  class: "username"
};
const _hoisted_25 = {
  class: "label"
};
const _hoisted_26 = {
  class: "flex-column-box border-left-box"
};
const _hoisted_27 = {
  class: "text"
};
const _hoisted_28 = {
  class: "flex-column-box border-left-box"
};
const _hoisted_29 = {
  class: "text"
};
const _hoisted_30 = {
  class: "flex-column-box border-left-box"
};
const _hoisted_31 = {
  class: "text"
};
const _hoisted_32 = {
  key: 1,
  class: "btn"
};
const _hoisted_33 = {
  class: "flex-column-box border-left-box"
};
const _hoisted_34 = {
  class: "text"
};
const _hoisted_35 = {
  key: 0,
  style: {
    "color": "gray"
  }
};
const _hoisted_36 = {
  key: 0,
  class: "flex-column-box border-left-box"
};
const _hoisted_37 = {
  class: "platforms-accredit text"
};
const _hoisted_38 = {
  class: "card-box"
};
const _hoisted_39 = {
  class: "rest-wrap"
};
const _hoisted_40 = {
  class: "label"
};
const _hoisted_41 = {
  class: "rest-value"
};
const _hoisted_42 = {
  key: 0,
  class: "value"
};
const _hoisted_43 = {
  class: "value-text"
};
const _hoisted_44 = {
  key: 1,
  class: "value"
};
const _hoisted_45 = {
  class: "value-text"
};
const _hoisted_46 = {
  class: "table-wrap"
};
const _hoisted_47 = {
  class: "dialog-footer"
};
const _hoisted_48 = {
  class: "code-bg"
};
const _hoisted_49 = ["src"];
const _hoisted_50 = {
  class: "bind-container"
};
const _hoisted_51 = {
  class: "bind-content"
};
const _hoisted_52 = {
  class: "qrcode-wrapper"
};
const _hoisted_53 = {
  key: 0,
  class: "qrcode"
};
const _hoisted_54 = ["src"];
const _hoisted_55 = {
  key: 1,
  class: "loading-qrcode"
};
const _hoisted_56 = {
  key: 0,
  style: {
    "color": "#5754f9",
    "margin-top": "10px"
  }
};
import { ref, onMounted, watch, computed, onUnmounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { getLoginUserInfo } from '@/request/index';
import { getBindMedia, checkCookie, getMediaType } from '@/request/mediaPlatform';
import { getAppUserConsumeRecordPage, getAppUserAmountInfo, resetAppUserPassword, updatePhone, getMemberExpiresTime } from '@/request/user';
import addAccountTable from './components/addAccountTable.vue';
import addPlate from './components/addPlate.vue';
import integralHistory from './components/integralHistory.vue';
import { getToken } from '@/api';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/index'

import { updateNicknameApi, updateHeadApi, wxBindWx, wxGetWxBindInfo } from '@/request/user';
import { emitter } from '@/utils/events';
import { checkPasswordRule, level } from '@/utils/form';
import { useUserStore } from '@/pinia';
import AvatarEditor from './components/AvatarEditor.vue';
import { useUserPackResource } from '@/views/serviceHall/taskCenter/useTaskCenter';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      szrPackages,
      fetchUserResource
    } = useUserPackResource();
    const router = useRouter();
    const route = useRoute();
    const user = ref({});
    const userStore = useUserStore();
    // 用户信息
    const userInfo = computed(() => {
      return userStore.getUserInfo;
    });
    // 资源字典
    const filteredResources = computed(() => {
      var _szrPackages$value;
      // 创建一个包含积分的基础对象
      const integralResource = [{
        icon: 'ri-award-line',
        makeType: 'INTEGRAL',
        label: '积分',
        usableCount: amountInfo.value.availableRechargeBalance || 0
      }];
      // 合并积分和过滤后的资源字典
      const temp = (_szrPackages$value = szrPackages.value) === null || _szrPackages$value === void 0 ? void 0 : _szrPackages$value.filter(item => item.makeType !== 'SELF_VIRTUAL_MAN' && item.makeType !== 'SELF_PHOTO_VIDEO');
      return [...integralResource, ...(temp || [])];
    });
    const mediaDic = {
      douyin: 'tiktok',
      bilibili: 'Bilibili'
    };
    const consumeTableData = ref([]);
    const consumeColumns = ref([{
      label: '消费类型',
      prop: 'consumeType',
      formatter: (row, column, cellvalue) => {
        return cellvalue == 1 ? '声音' : cellvalue == 2 ? '视频' : '知识库';
      }
    }, {
      label: '数字人名称',
      prop: 'virtualManName'
    }, {
      label: '音色名称',
      prop: 'timbreName'
    }, {
      label: '消费时长',
      prop: 'duration',
      formatter: (row, column, cellvalue) => {
        return cellvalue + '毫秒';
      }
    }, {
      label: 'AI文案字数',
      prop: 'wordNum'
    }, {
      label: '消费状态',
      prop: 'status',
      formatter: (row, column, cellvalue) => {
        return cellvalue == 1 ? '消费中' : cellvalue == 2 ? '消费成功' : '消费失败';
      }
    }, {
      label: '消费时间',
      prop: 'createTime'
    }]);
    const orderTableData = ref([]);
    const orderColumns = ref([{
      label: '订单标题',
      prop: 'orderTitle'
    }, {
      label: '订单状态',
      prop: 'memberOrderStatus',
      formatter: (row, column, cellvalue) => {
        return cellvalue == 1 ? '待付款' : cellvalue == 2 ? '已生效' : null;
      }
    }, {
      label: '订单金额',
      prop: 'orderAmount'
    }, {
      label: '会员权益名称',
      prop: 'memberBenefitName'
    }, {
      label: '开通会员类型',
      prop: 'openMemberType',
      formatter: (row, column, cellvalue) => {
        return cellvalue == 1 ? '月' : '年';
      }
    }, {
      label: '订单描述',
      prop: 'orderDesc'
    }, {
      label: '生效时间',
      prop: 'effectTime'
    }, {
      label: '失效时间',
      prop: 'expiresTime'
    }, {
      label: '是否支付',
      prop: 'isPay',
      formatter: (row, column, cellvalue) => {
        return cellvalue == 1 ? '是' : '否';
      }
    }, {
      label: '支付方式',
      prop: 'payWay',
      formatter: (row, column, cellvalue) => {
        return cellvalue == 1 ? '扫码支付' : '余额支付';
      }
    }, {
      label: '支付订单号	',
      prop: 'transactionId'
    }, {
      label: '每月可生成视频时长',
      prop: 'monthVideoDuration',
      formatter: (row, column, cellvalue) => {
        return cellvalue + '分钟';
      }
    }, {
      label: '每天可生成声音次数	',
      prop: 'dayVoiceNum',
      formatter: (row, column, cellvalue) => {
        return cellvalue + '次';
      }
    }, {
      label: 'AI文案生成字数限制',
      prop: 'aiWordNumLimit'
    }, {
      label: '知识库大小',
      prop: 'knowledgeMbSize',
      formatter: (row, column, cellvalue) => {
        return cellvalue + 'MB';
      }
    }, {
      label: '剩余知识库大小',
      prop: 'residueKnowledgeSize',
      formatter: (row, column, cellvalue) => {
        return cellvalue + 'byte';
      }
    }, {
      label: '团队ID',
      prop: 'teamId'
    }, {
      label: '团队名称',
      prop: 'teamName'
    }, {
      label: '创建时间',
      prop: 'createTime'
    }]);
    const expiresTime = ref('');
    const fetchMemberExpiresTime = async () => {
      var _res$data;
      const res = await getMemberExpiresTime();
      expiresTime.value = res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data;
    };
    fetchMemberExpiresTime();
    const formatterValue = (row, column, cellvalue) => {
      return cellvalue || '-';
    };
    const visible = ref(false);
    const loaidng = ref(false);
    const innerVisible = ref(false);
    const accreditVisible = ref(false);
    const openTrackSettingDialog = () => {
      emitter.emit('openTrackSettingDialog');
    };
    // const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const queryForm = ref({
      origin: '',
      consumeType: '',
      payWay: '',
      endCreateTime: '',
      startCreateTime: '',
      date: [],
      memberOrderStatus: ''
    });
    const originOptions = ref([]);
    const tradeOptions = ref([{
      label: '声音',
      value: 1
    }, {
      label: '视频',
      value: 2
    }, {
      label: '知识库',
      value: 3
    }]);
    const memberOrderStatus = ref([{
      label: '待付款',
      value: 1
    }, {
      label: '已生效',
      value: 2
    }]);
    const payOptions = ref([]);
    let bindMediaArr = ref([]);
    const onDateChange = val => {
      const [timeStart, timeEnd] = val;
      queryForm.value.startCreateTime = timeStart + ' 00:00:00';
      queryForm.value.endCreateTime = timeEnd + ' 23:59:59';
      onSearch();
    };
    const onSearch = () => {
      currentPage.value = 1;
      getData();
    };
    const changeType = v => {
      console.error(v);
    };
    const getUserInfo = () => {
      getLoginUserInfo().then(res => {
        const {
          code,
          data
        } = res.data;
        if (code == 200) {
          user.value = data;
          userStore.setUserInfo(data);
        }
      });
    };
    getUserInfo();
    const amountInfo = ref({});
    const getAmountInfo = () => {
      loaidng.value = true;
      getAppUserAmountInfo().then(res => {
        const {
          code,
          data
        } = res.data;
        if (code == 200) {
          amountInfo.value = data;
          loaidng.value = false;
        }
      }).finally(() => {
        loaidng.value = false;
      });
    };
    getAmountInfo();
    // const resourceStore = useUserResourceStore();
    // const { userResourceInfo } = storeToRefs(resourceStore);
    const getBindMediaFn = async () => {
      try {
        const res = await getBindMedia();
        // @ts-ignore
        bindMediaArr.value = [...res.data.data];
        // const checkPromises = res.data.data.map(async (item) => {
        //   try {
        //     const checkRes = await checkCookie({ account: item.id });
        //     let state = checkRes.data.code === 500 ? '需重新解绑授权' : '正常';
        //     return { ...item, state };
        //   } catch (error) {
        //     console.error('检查Cookie时出错', error);
        //     return { ...item, state: '异常' }; // 或者您可以选择其他默认状态
        //   }
        // });
        // // 等待所有checkCookie调用完成
        // bindMediaArr.value = await Promise.all(checkPromises);
        // 并行处理每个项，并立即更新状态
        const updateStatePromises = bindMediaArr.value.map(async (item, index) => {
          try {
            // @ts-ignore
            const checkRes = await checkCookie({
              account: item.id
            });
            const state = checkRes.data.code === 500 ? '需重新解绑授权' : '正常';
            // 立即更新  bindMediaArr.value  中对应项的状态
            // @ts-ignore
            bindMediaArr.value[index] = {
              ...item,
              state
            };
          } catch (error) {
            console.error('检查Cookie时出错', error);
            // @ts-ignore
            bindMediaArr.value[index] = {
              ...item,
              state: '异常'
            };
          }
        });
        // 等待所有状态更新完成
        await Promise.all(updateStatePromises);
      } catch (error) {
        console.error('获取绑定媒体失败', error);
      }
    };
    const accreditFn = () => {
      accreditVisible.value = true;
      getBindMediaFn();
    };
    const formatterBenefit = () => {
      switch (Number(user.value.memberBenefitId)) {
        case 2:
          return 'VIP';
        case 3:
          return 'SVIP';
        case 4:
          return '企业VIP';
        default:
          return '您还不是会员';
      }
    };
    const total = ref(0);
    const currentPage = ref(1);
    const handleCurrentChange = val => {
      currentPage.value = val;
      getData();
    };
    const activeTab = ref(3);
    const toggleTab = val => {
      activeTab.value = val;
      currentPage.value = 3;
      total.value = 3;
      getData();
    };
    const getData = () => {
      if (activeTab.value == 1) {
        getConsumeRecordData();
      } else {
        getMemberBenefitOrderPagea();
      }
    };
    const getConsumeRecordData = () => {
      getAppUserConsumeRecordPage({
        pageIndex: currentPage.value,
        pageSize: 10,
        consumeType: queryForm.value.consumeType,
        startCreateTime: queryForm.value.startCreateTime,
        endCreateTime: queryForm.value.endCreateTime
      }).then(res => {
        const {
          data
        } = res.data;
        total.value = data.total || 0;
        consumeTableData.value = data.list || [];
      });
    };
    const getMemberBenefitOrderPagea = () => {
      // getAppMemberBenefitOrderPage({
      //   pageIndex: currentPage.value,
      //   pageSize: 10,
      //   memberOrderStatus: queryForm.value.memberOrderStatus,
      //   startCreateTime: queryForm.value.startCreateTime,
      //   endCreateTime: queryForm.value.endCreateTime,
      // }).then((res) => {
      //   const { data } = res.data;
      //   total.value = data.total || 0;
      //   orderTableData.value = data.list || [];
      // });
    };
    getData();
    const editVisible = ref(false);
    const editType = ref('');
    const updateNickname = ref('');
    const phone = ref('');
    const password = ref('');
    const oldPassword = ref('');
    // 强度条颜色
    const barColor = ref('');
    // 强度条长度
    const width = ref('');
    // 强度条说明
    const strength = ref('');
    let userFormRef = ref();
    let userForm = ref({
      phone: '',
      password: '',
      updateNickname: '',
      currentHead: '',
      username: JSON.parse(localStorage.getItem('userInfo') || '{}').username
    });
    let dialogVisible = ref(false);
    let userFormRules = ref({
      password: [{
        required: true,
        message: '密码是必填项',
        trigger: 'blur'
      }, {
        validator: (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请输入密码'));
          } else {
            let name = '';
            if (userForm.value.username === '') {
              name = '空';
            } else {
              name = userForm.value.username;
            }
            const result = checkPasswordRule(value, name);
            if (result === '校验通过') {
              callback();
            } else {
              callback(new Error(result));
            }
          }
        },
        trigger: 'blur'
      }],
      currentHead: [{
        required: true,
        message: '头像不能为空',
        trigger: 'blur'
      }],
      updateNickname: [{
        required: true,
        message: '昵称不能为空',
        trigger: 'blur'
      }],
      phone: [{
        required: true,
        message: '手机号不为空',
        trigger: 'blur'
      }, {
        pattern: /^1[3-9]\d{9}$/,
        message: '手机号格式错误',
        trigger: 'blur'
      }]
    });
    // 监听注册页面的新密码变化状态，来改变密码强弱显示
    watch(() => userForm.value.password, newVal => {
      if (newVal != '') {
        const res = level(newVal);
        if (res == '非常弱') {
          barColor.value = 'red';
          width.value = '20';
          strength.value = '非常弱';
        } else if (res == '弱') {
          barColor.value = '#ee795c';
          width.value = '40';
          strength.value = '弱';
        } else if (res == '一般') {
          barColor.value = 'orange';
          width.value = '60';
          strength.value = '一般';
        } else if (res == '强') {
          barColor.value = 'green';
          width.value = '80';
          strength.value = '强';
        } else if (res == '非常强') {
          barColor.value = '#1B8EF8';
          width.value = '100';
          strength.value = '非常强';
        }
      }
    });
    let uploadDisabled = computed(() => {
      var _userForm$value;
      return ((_userForm$value = userForm.value) === null || _userForm$value === void 0 ? void 0 : _userForm$value.currentHead) !== '';
    });
    const editUser = type => {
      editType.value = type;
      // @ts-ignore
      headList.value = [{
        url: user.value.head || ''
      }];
      // @ts-ignore
      userForm.value.currentHead = user.value.head;
      // @ts-ignore
      userForm.value.updateNickname = user.value.nickname;
      // @ts-ignore
      userForm.value.phone = user.value.phone;
      editVisible.value = true;
    };
    const headList = ref([]);
    const baseApi = process.env.VUE_APP_API_BASE_URL;
    const headers = {
      Authorization: getToken()
    };
    const handleBeforeUpload = rawFile => {
      if (!rawFile.type.includes('png') && !rawFile.type.includes('jpg') && !rawFile.type.includes('jpeg')) {
        ElMessage.error('仅支持上传png、jpg、jpeg图片!');
        return false;
      }
      if (rawFile.size > 1 * 1024 * 1024) {
        ElMessage.error('上传图片大小不能超过1M！');
        return false;
      }
      return true;
    };
    const handleHeadSuccess = res => {
      userForm.value.currentHead = res.data.url;
    };
    const handleHeadError = () => {
      headList.value = [];
    };
    const handleHeadChange = file => {
      // @ts-ignore
      headList.value = [file];
    };
    let handleUpdateInfo = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          if (editType.value === 'password') {
            resetAppUserPassword({
              password: md5(userForm.value.password)
            }).then(() => {
              editVisible.value = false;
              ElMessage.success('密码修改成功，请重新登录');
              localStorage.setItem('token', '');
              localStorage.setItem('teamId', '');
              router.push('/login');
            });
          } else {
            Promise.all([updateNicknameApi({
              nickname: userForm.value.updateNickname
            }), updateHeadApi({
              head: userForm.value.currentHead || user.value.head
            }), updatePhone({
              phone: userForm.value.phone
            })]).then(responses => {
              editVisible.value = false;
              ElMessage.success('信息已更新');
              getUserInfo();
            });
          }
        } else {
          console.log('error submit!');
          return false;
        }
      });
    };
    const mediaData = ref([]);
    const getMediaTypeFn = () => {
      getMediaType().then(({
        data
      }) => {
        if (data.code !== 200) return;
        mediaData.value = data.data.filter(v => v.value === 'douyin');
      });
    };
    onMounted(() => {
      var _route$query;
      getMediaTypeFn();
      // 如果路由有operate
      if (((_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.operate) === 'bindWechat' && !user.openid) {
        wxBindDialog.value = true;
      }
      // resourceStore.fetchUserResourceInfo();
      fetchUserResource();
      emitter.on('trackSettingDialogClosed', () => {
        // 处理弹窗关闭后的逻辑
        console.log('弹窗已关闭');
      });
      emitter.on('refreshIntegral', () => {
        getAmountInfo();
      });
    });
    // 微信绑定
    let wxBindTimer = undefined;
    let wxBindDialog = ref(false);
    let wxBindQrcode = ref('');
    let wxBindStatus = ref('');
    let openWxBind = () => {
      wxBindWx().then(res => {
        const {
          data,
          code
        } = res.data;
        if (code === 200) {
          wxBindQrcode.value = data.qrcode;
          startWxBindPolling(data.sceneStr);
        }
      }).catch(err => {
        console.error('获取二维码失败，请重试', err);
      });
    };
    const startWxBindPolling = sceneStr => {
      if (wxBindTimer) {
        clearInterval(wxBindTimer);
      }
      wxBindTimer = setInterval(async () => {
        // try {
        const res = await wxGetWxBindInfo(sceneStr);
        const {
          code,
          msg
        } = res.data;
        if (code === 200) {
          clearInterval(wxBindTimer);
          wxBindDialog.value = false;
          if (msg !== wxBindStatus.value) wxBindStatus.value = msg;
          ElMessage.success('微信绑定成功');
          getUserInfo(); // 刷新用户信息
        } else {
          if (msg !== wxBindStatus.value) wxBindStatus.value = msg;
          // ElMessage.warning(msg);
        }
      }, 3000); // 每3秒轮询一次
    };
    const closeWxBindDialog = () => {
      if (wxBindTimer) {
        clearInterval(wxBindTimer);
        wxBindTimer = undefined;
      }
      wxBindDialog.value = false;
    };
    onUnmounted(() => {
      if (wxBindTimer) {
        clearInterval(wxBindTimer);
      }
    });
    // 添加新的响应式变量
    const showAvatarHover = ref(false);
    const avatarEditorVisible = ref(false);
    // 添加新的方法
    const openAvatarEditor = () => {
      avatarEditorVisible.value = true;
    };
    const handleAvatarSave = async url => {
      try {
        console.log(url, 'asdasd');
        await updateHeadApi({
          head: url
        });
        user.value.head = url;
        ElMessage.success('头像更新成功');
        getUserInfo(); // 刷新用户信息
      } catch (error) {
        ElMessage.error('头像更新失败');
      }
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      const _component_svgIcon = _resolveComponent("svgIcon");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_InfoFilled = _resolveComponent("InfoFilled");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_scrollbar, {
        style: {
          "padding-right": "16px"
        }
      }, {
        default: _withCtx(() => {
          var _userInfo$value, _userInfo$value2;
          return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
            class: "avatar-item",
            onMouseenter: _cache[0] || (_cache[0] = $event => showAvatarHover.value = true),
            onMouseleave: _cache[1] || (_cache[1] = $event => showAvatarHover.value = false)
          }, [user.value.head ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: user.value.head,
            class: "avatar-img"
          }, null, 8, _hoisted_5)) : (_openBlock(), _createElementBlock("i", _hoisted_6)), _withDirectives(_createElementVNode("div", {
            class: "avatar-hover",
            onClick: openAvatarEditor
          }, _cache[24] || (_cache[24] = [_createElementVNode("i", {
            class: "ri-camera-line"
          }, null, -1), _createElementVNode("span", null, "更换头像", -1)]), 512), [[_vShow, showAvatarHover.value]])], 32)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, [_cache[25] || (_cache[25] = _createTextVNode("你好，")), _createElementVNode("span", _hoisted_9, _toDisplayString(user.value.nickname), 1)]), _createElementVNode("div", _hoisted_10, [(_userInfo$value = userInfo.value) !== null && _userInfo$value !== void 0 && _userInfo$value.profession ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(((_userInfo$value2 = userInfo.value) === null || _userInfo$value2 === void 0 ? void 0 : _userInfo$value2.profession) || ''), 1)) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            size: "small",
            type: "text",
            class: "profession-add",
            onClick: openTrackSettingDialog
          }, {
            default: _withCtx(() => {
              var _userInfo$value3;
              return [_cache[26] || (_cache[26] = _createElementVNode("i", {
                class: "ri-add-circle-line"
              }, null, -1)), _createTextVNode(" " + _toDisplayString((_userInfo$value3 = userInfo.value) !== null && _userInfo$value3 !== void 0 && _userInfo$value3.profession ? '编辑创作偏好' : '添加创作偏好'), 1)];
            }),
            _: 1
          })])])])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_descriptions, null, {
            title: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_cache[29] || (_cache[29] = _createElementVNode("div", {
              class: "card-title"
            }, "个人信息", -1)), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_button, {
              type: "text",
              class: "label",
              style: {
                "cursor": "pointer"
              },
              onClick: editUser
            }, {
              default: _withCtx(() => _cache[27] || (_cache[27] = [_createTextVNode(" 修改个人信息 ")])),
              _: 1
            }), _createVNode(_component_el_button, {
              type: "text",
              class: "label",
              onClick: _cache[2] || (_cache[2] = $event => editUser('password'))
            }, {
              default: _withCtx(() => _cache[28] || (_cache[28] = [_createTextVNode(" 修改密码 ")])),
              _: 1
            })])])]),
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, null, {
              label: _withCtx(() => _cache[30] || (_cache[30] = [_createElementVNode("div", {
                class: "cell-item"
              }, [_createElementVNode("i", {
                class: "ri-user-line"
              }), _createTextVNode(" 用户名 : ")], -1)])),
              default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(user.value.nickname), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, null, {
              label: _withCtx(() => _cache[31] || (_cache[31] = [_createElementVNode("div", {
                class: "cell-item"
              }, [_createElementVNode("i", {
                class: "ri-phone-line"
              }), _createTextVNode(" 手机号 : ")], -1)])),
              default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(user.value.phone), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, null, {
              label: _withCtx(() => _cache[32] || (_cache[32] = [_createElementVNode("div", {
                class: "cell-item"
              }, [_createElementVNode("i", {
                class: "ri-wechat-2-line"
              }), _createTextVNode(" 微信 : ")], -1)])),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createTextVNode(_toDisplayString(user.value.wxname) + " ", 1), !user.value.openid ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                size: "small",
                class: "custom-btn",
                onClick: _cache[3] || (_cache[3] = $event => _isRef(wxBindDialog) //@ts-ignore
                ? wxBindDialog.value = true : wxBindDialog = true)
              }, {
                default: _withCtx(() => _cache[33] || (_cache[33] = [_createTextVNode("去绑定")])),
                _: 1
              })) : _createCommentVNode("", true), user.value.openid ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                size: "small",
                class: "custom-btn",
                disabled: true
              }, {
                default: _withCtx(() => _cache[34] || (_cache[34] = [_createTextVNode("已绑定")])),
                _: 1
              })) : _createCommentVNode("", true)])]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, null, {
              label: _withCtx(() => _cache[35] || (_cache[35] = [_createElementVNode("div", {
                class: "cell-item"
              }, [_createElementVNode("i", {
                class: "ri-brush-ai-line"
              }), _createTextVNode(" 创作者信息 : ")], -1)])),
              default: _withCtx(() => {
                var _userInfo$value4;
                return [_createElementVNode("span", _hoisted_16, [_createElementVNode("span", null, _toDisplayString(((_userInfo$value4 = userInfo.value) === null || _userInfo$value4 === void 0 ? void 0 : _userInfo$value4.profession) || ''), 1)])];
              }),
              _: 1
            }), _createVNode(_component_el_descriptions_item, null, {
              label: _withCtx(() => _cache[36] || (_cache[36] = [_createElementVNode("div", {
                class: "cell-item"
              }, [_createElementVNode("i", {
                class: "ri-user-line"
              }), _createTextVNode(" 会员信息 : ")], -1)])),
              default: _withCtx(() => [_createElementVNode("span", _hoisted_17, [_createElementVNode("div", {
                class: _normalizeClass(Number(user.value.memberBenefitId) !== 3 ? 'vip-plain' : 'vip-dark')
              }, [_createElementVNode("span", _hoisted_18, _toDisplayString(formatterBenefit()), 1)], 2)])]),
              _: 1
            })]),
            _: 1
          })]), _createElementVNode("div", _hoisted_19, [_cache[44] || (_cache[44] = _createElementVNode("div", {
            class: "card-title"
          }, "账户资源", -1)), false ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [user.value.head ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: user.value.head,
            class: "avatar"
          }, null, 8, _hoisted_22)) : (_openBlock(), _createElementBlock("i", _hoisted_23)), _createElementVNode("div", null, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_24, _toDisplayString(user.value.nickname), 1), _createVNode(_component_svgIcon, {
            iconClass: "edit2",
            width: "0.833vw",
            onClick: editUser,
            style: {
              "cursor": "pointer"
            }
          })]), _createElementVNode("p", _hoisted_25, [_createElementVNode("a", {
            class: "btn",
            onClick: _cache[4] || (_cache[4] = $event => editUser('password'))
          }, "修改密码")])])]), _createElementVNode("div", _hoisted_26, [_cache[37] || (_cache[37] = _createElementVNode("p", {
            class: "label"
          }, "用户ID", -1)), _createElementVNode("p", _hoisted_27, _toDisplayString(user.value.userId), 1)]), _createElementVNode("div", _hoisted_28, [_cache[38] || (_cache[38] = _createElementVNode("p", {
            class: "label"
          }, "手机号", -1)), _createElementVNode("p", _hoisted_29, _toDisplayString(user.value.phone), 1)]), _createElementVNode("div", _hoisted_30, [_cache[39] || (_cache[39] = _createElementVNode("p", {
            class: "label"
          }, "微信", -1)), _createElementVNode("p", _hoisted_31, [_createTextVNode(_toDisplayString(user.value.wxname) + " ", 1), !user.value.openid ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "btn",
            onClick: _cache[5] || (_cache[5] = $event => _isRef(wxBindDialog) //@ts-ignore
            ? wxBindDialog.value = true : wxBindDialog = true)
          }, "去绑定")) : _createCommentVNode("", true), user.value.openid ? (_openBlock(), _createElementBlock("a", _hoisted_32, "已绑定")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_33, [_cache[40] || (_cache[40] = _createElementVNode("p", {
            class: "label"
          }, "会员信息", -1)), _createElementVNode("p", _hoisted_34, [_createTextVNode(_toDisplayString(formatterBenefit()) + " ", 1), !!expiresTime.value ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(expiresTime.value) + "到期", 1)) : _createCommentVNode("", true)])]), false ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_cache[41] || (_cache[41] = _createElementVNode("p", {
            class: "label"
          }, "多平台授权", -1)), _createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mediaData.value, i => {
            return _openBlock(), _createElementBlock("div", {
              key: i.value,
              class: "platform-item"
            }, [_createVNode(_component_svgIcon, {
              iconClass: mediaDic[i.value],
              width: "2vw",
              height: "2vw",
              class: "platform-icon"
            }, null, 8, ["iconClass"]), _createElementVNode("a", {
              class: "btn auth-btn",
              onClick: accreditFn
            }, "设置")]);
          }), 128))])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_38, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredResources.value, (item, key) => {
            return _openBlock(), _createElementBlock("div", {
              class: "card-item",
              key: key
            }, [_createElementVNode("div", _hoisted_39, [_createElementVNode("p", _hoisted_40, _toDisplayString(item.label), 1), _createElementVNode("div", _hoisted_41, [_createElementVNode("i", {
              class: _normalizeClass(item.icon)
            }, null, 2), item.makeType === 'INTEGRAL' ? (_openBlock(), _createElementBlock("p", _hoisted_42, [_createElementVNode("span", _hoisted_43, _toDisplayString(item.usableCount), 1), _cache[42] || (_cache[42] = _createElementVNode("span", {
              class: "value-unit"
            }, "积分", -1))])) : (_openBlock(), _createElementBlock("p", _hoisted_44, [_createElementVNode("span", _hoisted_45, _toDisplayString(item.usableCount), 1), _cache[43] || (_cache[43] = _createElementVNode("span", {
              class: "value-unit"
            }, "个", -1))]))])])]);
          }), 128))])]), _createElementVNode("div", _hoisted_46, [_cache[45] || (_cache[45] = _createElementVNode("div", {
            class: "card-title",
            style: {
              "margin-bottom": "20px"
            }
          }, " 积分历史 ", -1)), [1, 2].includes(activeTab.value) ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_el_row, {
            gutter: 20,
            style: {
              "margin-bottom": "20px"
            }
          }, {
            default: _withCtx(() => [activeTab.value == 1 ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 4
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: queryForm.value.consumeType,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => queryForm.value.consumeType = $event),
                placeholder: "请选择交易类型",
                style: {
                  "width": "100%"
                },
                onChange: onSearch,
                clearable: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tradeOptions.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 6
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: queryForm.value.date,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => queryForm.value.date = $event),
                type: "daterange",
                "unlink-panels": "",
                "range-separator": "至",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
                "value-format": "YYYY-MM-DD",
                onChange: onDateChange
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), activeTab.value == 1 ? (_openBlock(), _createBlock(_component_el_table, {
            key: 0,
            data: consumeTableData.value,
            style: {
              "width": "100%"
            },
            height: "850",
            size: "default"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              type: "index",
              label: "序号",
              width: "50"
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(consumeColumns.value, c => {
              return _openBlock(), _createBlock(_component_el_table_column, {
                key: c.prop,
                prop: c.prop,
                label: c.label,
                formatter: c.formatter || formatterValue
              }, null, 8, ["prop", "label", "formatter"]);
            }), 128))]),
            _: 1
          }, 8, ["data"])) : _createCommentVNode("", true), activeTab.value == 2 ? (_openBlock(), _createBlock(_component_el_table, {
            key: 1,
            data: orderTableData.value,
            style: {
              "width": "100%"
            },
            height: "450"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              type: "index",
              label: "序号",
              width: "50"
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderColumns.value, c => {
              return _openBlock(), _createBlock(_component_el_table_column, {
                key: c.prop,
                prop: c.prop,
                label: c.label,
                formatter: c.formatter || formatterValue
              }, null, 8, ["prop", "label", "formatter"]);
            }), 128))]),
            _: 1
          }, 8, ["data"])) : _createCommentVNode("", true), _createVNode(_component_el_pagination, {
            onCurrentChange: handleCurrentChange,
            background: true,
            currentPage: currentPage.value,
            "onUpdate:currentPage": _cache[8] || (_cache[8] = $event => currentPage.value = $event),
            "page-size": 10,
            layout: "total, prev, pager, next",
            total: total.value
          }, null, 8, ["currentPage", "total"])], 64)) : _createCommentVNode("", true), [3].includes(activeTab.value) ? (_openBlock(), _createBlock(integralHistory, {
            key: 1
          })) : _createCommentVNode("", true)])];
        }),
        _: 1
      }), _createVNode(_component_el_dialog, {
        class: "custom-el-dialog",
        modelValue: editVisible.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => editVisible.value = $event),
        title: `修改${editType.value === 'password' ? '密码' : '个人信息'}`,
        width: "600px"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_47, [_createVNode(_component_el_button, {
          onClick: _cache[13] || (_cache[13] = $event => editVisible.value = false)
        }, {
          default: _withCtx(() => _cache[48] || (_cache[48] = [_createTextVNode("取 消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[14] || (_cache[14] = $event => _unref(handleUpdateInfo)(_unref(userFormRef)))
        }, {
          default: _withCtx(() => _cache[49] || (_cache[49] = [_createTextVNode("确 定")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: _unref(userForm),
          ref_key: "userFormRef",
          ref: userFormRef,
          rules: _unref(userFormRules)
        }, {
          default: _withCtx(() => [editType.value === 'password' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_el_form_item, {
            label: "账号"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(userForm).username,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(userForm).username = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "新密码",
            prop: "password"
          }, {
            label: _withCtx(() => [_createElementVNode("span", null, [_cache[47] || (_cache[47] = _createTextVNode("新密码 ")), _createVNode(_component_el_tooltip, {
              placement: "top"
            }, {
              content: _withCtx(() => _cache[46] || (_cache[46] = [_createElementVNode("div", {
                style: {
                  "font-size": "11px"
                }
              }, [_createTextVNode(" 不能包含用户名；"), _createElementVNode("br"), _createTextVNode(" 不能包含3个及以上相同或连续的字符；"), _createElementVNode("br"), _createTextVNode(" 不能包含3个及以上键盘连续字符；(横向、斜向都包括)"), _createElementVNode("br"), _createTextVNode(" 必须数字、小写字母、大写字母、特殊字符，至少包含两种 ")], -1)])),
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_InfoFilled)]),
                _: 1
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(userForm).password,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(userForm).password = $event),
              placeholder: "请输入新密码",
              type: "password",
              "show-password": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _unref(userForm).password !== '' && _unref(userForm).password !== undefined ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "",
            align: "center",
            style: {
              "height": "25px",
              "margin-left": "80px"
            }
          }, {
            default: _withCtx(() => [_unref(userForm).password !== '' && _unref(userForm).password !== undefined ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "bar",
              style: _normalizeStyle({
                background: barColor.value,
                width: width.value + '%'
              })
            }, [_unref(userForm).password !== '' && _unref(userForm).password !== undefined ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "strength",
              style: _normalizeStyle({
                color: barColor.value
              })
            }, _toDisplayString(strength.value), 5)) : _createCommentVNode("", true)], 4)) : _createCommentVNode("", true)]),
            _: 1
          })) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_el_form_item, {
            label: "昵称",
            "label-width": "80px",
            "label-align": "left",
            prop: "updateNickname"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(userForm).updateNickname,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(userForm).updateNickname = $event),
              placeholder: "请输入昵称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "手机号",
            "label-width": "80px",
            "label-align": "left",
            prop: "phone"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(userForm).phone,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(userForm).phone = $event),
              placeholder: "请输入手机号"
            }, null, 8, ["modelValue"])]),
            _: 1
          })], 64))]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        class: "custom-el-dialog",
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => visible.value = $event),
        title: "添加客服企业微信，开通直播功能",
        width: "500px",
        center: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_48, [_createVNode(_component_el_image, {
          src: require('@/assets/images/ewcode.png')
        }, null, 8, ["src"])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        class: "custom-el-dialog",
        modelValue: accreditVisible.value,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => accreditVisible.value = $event),
        title: "已绑定所属账号",
        width: "500px",
        center: ""
      }, {
        default: _withCtx(() => [_createVNode(addAccountTable, {
          onGetBindMediaFn: getBindMediaFn,
          bindMediaArr: _unref(bindMediaArr),
          onClickAdd: _cache[17] || (_cache[17] = $event => innerVisible.value = true)
        }, null, 8, ["bindMediaArr"]), innerVisible.value ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: innerVisible.value,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => innerVisible.value = $event),
          width: "500",
          title: "授权登录绑定所属账号",
          "append-to-body": ""
        }, {
          default: _withCtx(() => [innerVisible.value ? (_openBlock(), _createBlock(addPlate, {
            key: 0,
            innerVisible: innerVisible.value,
            "onUpdate:innerVisible": _cache[18] || (_cache[18] = $event => innerVisible.value = $event),
            onGetBindMediaFn: getBindMediaFn
          }, null, 8, ["innerVisible"])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : dialogVisible = $event),
        class: "custom-el-dialog"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          "w-full": "",
          src: _unref(userForm).currentHead,
          alt: "Preview Image"
        }, null, 8, _hoisted_49)]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(wxBindDialog),
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => _isRef(wxBindDialog) ? wxBindDialog.value = $event : wxBindDialog = $event),
        title: "绑定账号",
        width: "500px",
        center: "",
        class: "bind-dialog custom-el-dialog",
        onOpen: _unref(openWxBind),
        onClose: closeWxBindDialog
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_cache[52] || (_cache[52] = _createElementVNode("div", {
          class: "icon"
        }, [_createElementVNode("i", {
          class: "ri-qr-code-line"
        })], -1)), _cache[53] || (_cache[53] = _createElementVNode("h2", null, "扫码绑定微信", -1)), _cache[54] || (_cache[54] = _createElementVNode("p", null, "请使用微信扫描下方二维码完成绑定操作", -1)), _createElementVNode("div", _hoisted_52, [_unref(wxBindQrcode) ? (_openBlock(), _createElementBlock("div", _hoisted_53, [_createElementVNode("img", {
          src: _unref(wxBindQrcode),
          alt: "微信绑定二维码"
        }, null, 8, _hoisted_54)])) : (_openBlock(), _createElementBlock("div", _hoisted_55, _cache[50] || (_cache[50] = [_createElementVNode("i", {
          class: "el-icon-loading"
        }, null, -1), _createElementVNode("span", null, "二维码加载中...", -1)]))), _cache[51] || (_cache[51] = _createElementVNode("div", {
          class: "scan-line"
        }, null, -1))])]), _unref(wxBindStatus) ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(_unref(wxBindStatus)), 1)) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue", "onOpen"]), _createVNode(AvatarEditor, {
        modelValue: avatarEditorVisible.value,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => avatarEditorVisible.value = $event),
        "current-head": userInfo.value.head,
        onSave: handleAvatarSave
      }, null, 8, ["modelValue", "current-head"])]);
    };
  }
});